var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMercadopago(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "120.768 81.05 288.125 180.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 265.401,
    cy: 171.03,
    rx: 143.492,
    ry: 89.98,
    style: {
      fill: "rgb(0, 188, 255)",
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 264.137,
    cy: 171.19,
    rx: 143.369,
    ry: 90.14,
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 10,
      stroke: "rgb(10, 0, 128)",
      fill: "rgba(186, 218, 85, 0)",
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M 259.946 111.449 C 266.008 110.691 270.513 109.596 278.466 111.163 C 288.898 113.218 305.046 121.354 316.147 123.318 C 325.282 124.935 333.754 125.802 341.141 125.53 C 347.65 125.291 356.509 123.45 358.9 123.707 C 359.755 123.798 359.039 122.922 359.556 122.71 C 360.577 122.294 364.299 122.094 366.148 120.477 C 368.016 118.843 366.199 120.351 369.16 118.32 C 375.653 113.209 376.56 118.062 380.058 120.454 C 389.201 128.354 397.097 138.815 399.248 144.413 C 400.713 148.225 406.134 158.677 405.516 161.926 C 404.924 165.038 403.47 163.634 402.973 163.634 C 402.476 163.634 401.972 162.319 397.918 163.634 C 391.506 165.715 368.168 170.771 367.295 171.064 C 366.779 171.237 361.988 173.375 357.65 175.097 C 355.156 176.087 351.977 177.858 351.977 177.858 C 351.977 177.858 342.723 180.229 344.48 183.454 C 348.052 190.011 344.48 193.57 344.48 193.57 C 348.901 193.57 339.719 201.275 336.485 201.277 C 332.44 201.278 329.739 196.666 329.739 199.203 C 329.739 203.808 325.765 208.294 322.935 210.801 C 320.479 212.976 313.856 210.318 311.478 212.144 C 310.171 213.149 312.116 216.62 310.242 219.096 C 308.715 221.112 302.162 226.321 300.59 225.715 C 297.814 224.645 297.643 225.006 296.334 224.336 C 295.995 224.163 293.306 222.769 292.84 222.303 C 292.366 221.829 293.693 222.088 292.84 222.303 C 290.519 222.89 294.197 221.235 292.84 222.303 C 290.139 224.428 283.159 229.451 278.903 229.187 C 274.877 228.935 268.961 224.449 265.932 224.393 C 262.676 224.331 256.771 231.149 252.371 229.929 C 237.175 225.715 243.983 220.339 239.848 219.688 C 235.147 218.948 230.866 221.408 229.559 220.634 C 228.997 220.301 225.394 219.387 224.17 216.461 C 223.116 213.943 223.296 211.016 222.938 210.844 C 221.331 210.069 214.966 212.555 212.052 211.604 C 209.616 210.81 207.61 210.378 206.347 209.003 C 205.356 207.925 206.522 207.244 205.166 205.995 C 204.199 205.105 205.263 199.313 202.961 198.373 C 201.284 197.688 199.575 199.282 197.243 199.616 C 194.554 200 191.28 199.118 190.24 197.854 C 188.868 196.187 186.7 192.471 186.728 189.799 C 186.761 186.721 190.297 183.454 188.747 182.332 C 180.941 176.682 155.105 165.945 145.424 163.634 C 139.774 162.285 119.34 161.84 124.987 157.665 C 130.307 132.277 153.895 116.088 156.443 112.842 C 156.443 112.842 192.321 127.144 195.372 127.067 C 237.229 126.011 203.59 132.115 228.278 124.205 C 230.461 123.506 233.174 122.762 235.254 122.499 C 236.963 122.282 238.107 122.723 239.672 122.015 C 241.935 120.991 243.752 118.981 245.814 117.969 C 250.675 115.583 254.498 112.13 259.946 111.449 Z",
    style: {
      strokeWidth: 2,
      fill: "rgb(247, 247, 247)",
      fillRule: "nonzero",
      stroke: "rgb(255, 255, 255)",
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M 156.443 112.842 C 156.443 112.842 166.898 116.304 170.731 117.586 C 174.615 118.885 178.491 120.226 182.383 121.481 C 190.156 123.986 198.017 126.148 206.146 126.915 C 217.531 127.965 228.529 123.312 239.672 121.539",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 10,
      stroke: "rgb(10, 0, 128)",
      fill: "rgba(255, 255, 255, 0)",
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M 374.19 114.536 C 362.989 121.711 349.642 125.329 336.103 124.85 C 311.511 124.85 290.192 109.577 268.151 109.577 C 248.477 109.577 215.139 139.95 215.139 145.444 C 215.139 150.931 224.792 154.195 232.63 150.59 C 237.21 148.479 257.038 130.344 273.07 130.344 C 289.101 130.344 341.051 179.908 345.756 184.561 C 353.042 191.771 338.928 207.301 329.909 198.8 C 320.891 190.305 304.771 176.838 304.771 176.838",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 10,
      stroke: "rgb(10, 0, 128)",
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M 407.506 163.634 C 385.436 166.086 364.058 172.427 344.48 182.332",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 10,
      stroke: "rgb(10, 0, 128)",
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M 327.719 196.778 C 335.012 203.988 320.891 219.518 311.872 211.017 C 302.854 202.522 292.84 193.57 292.84 193.57",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 10,
      stroke: "rgb(10, 0, 128)",
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M 309.689 209.003 C 316.975 216.205 302.854 231.736 293.835 223.241 C 284.817 214.74 278.903 209.614 278.903 209.614",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 10,
      stroke: "rgb(10, 0, 128)",
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M 265.932 223.595 C 273.188 231.555 286.476 230.923 292.84 222.303",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 10,
      stroke: "rgb(10, 0, 128)",
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M 265.932 223.595 C 269.847 218.754 269.545 201.495 249.392 204.926 C 254.126 196.459 249.871 183.075 231.775 190.972 C 230.743 181.984 219.77 177.428 212.027 182.769 C 210.619 183.735 209.446 184.971 208.583 186.395 C 207.293 178.713 197.662 175.226 191.24 180.116 C 189.743 181.255 188.607 182.755 187.936 184.45 C 183.925 192.111 190.119 205.954 203.355 198.175 C 202.021 211.677 209.549 215.795 223.155 210.531 C 223.885 223.797 233.235 222.658 239.916 219.567 C 242.453 229.645 255.623 233.361 263.624 226.249 C 264.508 225.464 265.29 224.568 265.932 223.595 Z",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 10,
      stroke: "rgb(10, 0, 128)",
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M 121.909 160.821 C 143.579 162.248 168.977 170.233 188.747 183.151",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 10,
      stroke: "rgb(10, 0, 128)"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercadopago);
export default __webpack_public_path__ + "static/media/mercadopago.0e7071aee2386220f656984c9f52fe9c.svg";
export { ForwardRef as ReactComponent };